export default __webpack_public_path__ + "static/media/DataBarGraph.8355b827.svg";